import React from 'react';
import { Modal, Image, Button, Space, Typography } from 'antd';
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface FilePreviewProps {
  visible: boolean;
  fileUrl: string;
  fileName: string;
  fileType?: string;
  onClose: () => void;
  onDownload?: () => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  visible,
  fileUrl,
  fileName,
  fileType,
  onClose,
  onDownload,
}) => {
  // Determine if file is previewable
  const getFileExtension = (name: string): string => {
    const parts = name.split('.');
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  };

  const extension = getFileExtension(fileName);
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension);
  const isPdf = extension === 'pdf';
  const isPreviewable = isImage || isPdf;

  // Render preview content
  const renderPreviewContent = () => {
    if (isImage) {
      return (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Image
            src={fileUrl}
            alt={fileName}
            style={{ maxWidth: '100%', maxHeight: '70vh' }}
            preview={false}
          />
        </div>
      );
    }

    if (isPdf) {
      return (
        <div style={{ height: '70vh', width: '100%' }}>
          <iframe
            src={fileUrl}
            title={fileName}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        </div>
      );
    }

    // Not previewable
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '60px 20px',
          color: '#999',
        }}
      >
        <Text type="secondary" style={{ fontSize: 16 }}>
          此文件类型不支持预览
        </Text>
        <div style={{ marginTop: 16 }}>
          <Text type="secondary">
            文件名：{fileName}
          </Text>
        </div>
        <div style={{ marginTop: 24 }}>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={onDownload}
          >
            下载文件
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Modal
      title={
        <Space>
          <span>文件预览</span>
          <Text type="secondary" style={{ fontSize: 14, fontWeight: 'normal' }}>
            {fileName}
          </Text>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width={isPreviewable ? '80%' : 600}
      style={{ top: 20 }}
      footer={
        <Space>
          {isPreviewable && onDownload && (
            <Button icon={<DownloadOutlined />} onClick={onDownload}>
              下载
            </Button>
          )}
          <Button onClick={onClose} icon={<CloseOutlined />}>
            关闭
          </Button>
        </Space>
      }
      destroyOnClose
    >
      {renderPreviewContent()}
    </Modal>
  );
};

export default FilePreview;
